import { OPEN_ERROR_MODAL, CLOSE_ERROR_MODAL, SHOW_HELP_MODAL } from './types';

export const openErrorModal = message => dispatch => {
  dispatch({ type: OPEN_ERROR_MODAL, payload: message });
};

export const closeErrorModal = () => dispatch => {
  dispatch({ type: CLOSE_ERROR_MODAL });
};

export const showHelpModal = link => dispatch => {
  dispatch({ type: SHOW_HELP_MODAL, payload: link });
};
